import Collection from "../../../data-structures/collection";
import Webhook from "./webhook";

export default class WebhooksCollection extends Collection<Webhook> {

    static initFromJson(data:any[]): WebhooksCollection {

        const models = _.map(data, (record:any) => new Webhook(record))

        return new WebhooksCollection(models)
    }

    // Options for the send-webhook picker.
    toOptions() {
        return _.map(this.models, (webhook:Webhook) => {
            return {
                value   : webhook.id,
                label   : webhook.title,
                icon    : 'i5-webhook',
            }
        })
    }
}
